import React, { useEffect } from 'react'
import Navbar from '../Components/Layouts/Navbar'
import Footer from '../Components/Layouts/Footer'
import UserNavbar from '../Components/Layouts/UserNavbar';
import { isUser } from '../Config/isUser';
import { isCompany } from '../Config/isCompany';
import CompanyNavbar from '../Components/Layouts/CompanyNavbar';
import { isNewUser } from '../Config/isNewUser';
import { useNavigate } from 'react-router-dom';
import { isNewCompany } from '../Config/isNewCompany';

function MainLayout({ children }) {

  const navigate = useNavigate();

  useEffect(() => {
    if (isNewUser || isNewCompany) {
      navigate('/waiting-approval');
    }
    else if (localStorage.getItem('first') === '2') {
      navigate('/setPassword');
    }

   
  }, []);


  return (
    <div>
      {isUser ? <UserNavbar  /> : (isCompany ? <CompanyNavbar /> : <Navbar />)}
      {children}
      <Footer />
    </div>
  )
}

export default MainLayout